/**
 * @generated SignedSource<<08f8e13e5e83e2f59225ffc21c8f1d75>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type UnitDSelectDialogField_CourseTitle_courseQuery$variables = {
  id: string;
};
export type UnitDSelectDialogField_CourseTitle_courseQuery$data = {
  readonly course: {
    readonly id: string;
    readonly title: string;
  };
};
export type UnitDSelectDialogField_CourseTitle_courseQuery = {
  response: UnitDSelectDialogField_CourseTitle_courseQuery$data;
  variables: UnitDSelectDialogField_CourseTitle_courseQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Course",
    "kind": "LinkedField",
    "name": "course",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnitDSelectDialogField_CourseTitle_courseQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnitDSelectDialogField_CourseTitle_courseQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "dc30038b8bb63e78719e3659ba970885",
    "id": null,
    "metadata": {},
    "name": "UnitDSelectDialogField_CourseTitle_courseQuery",
    "operationKind": "query",
    "text": "query UnitDSelectDialogField_CourseTitle_courseQuery(\n  $id: ID!\n) {\n  course(id: $id) {\n    id\n    title\n  }\n}\n"
  }
};
})();

(node as any).hash = "10077953cc63f41508e635732e9d390f";

export default node;
